import React from 'react';
import PropTypes from 'prop-types';
import DatePickerComponent from './DatePickerComponent';

const FilterDateRange = ({
    filterData,
    handleDateFieldChange,
    fromLabel,
    toLabel,
    colLgClass,
    colSmClass,
    containerClasses,
    datepickerWrapperClass,
    dateFormat,
    fromFieldName,
    toFieldName,
    showTimeSelect,
    isRangeMode,
    showFutureDate,
    adjustDateOnChange,
    fromMinDate,
    fromMaxDate,
    toMinDate,
    toMaxDate,
    fromTestId,
    toTestId,
}) => {
    const parseDateValue = (value) => {
        if (!value) return null;
        const parsed = value instanceof Date ? value : new Date(value);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    return (
        <>
            <div data-testid={fromTestId} className={`${colLgClass} ${colSmClass} ${containerClasses}`}>
                <div className="row">
                    <div className="col-12">
                        <div className="labelHead">{fromLabel}</div>
                    </div>
                    <div className={`col-12 ${datepickerWrapperClass}`}>
                        <DatePickerComponent
                            dateField={filterData[fromFieldName]}
                            handleDateChange={date => handleDateFieldChange(date, fromFieldName)}
                            fieldName={fromFieldName}
                            dateFormat={dateFormat}
                            timeSelect={showTimeSelect}
                            isRange={isRangeMode}
                            showFutureDate={showFutureDate}
                            adjustDateOnChange={adjustDateOnChange}
                            minDate={parseDateValue(fromMinDate)}
                            maxDate={parseDateValue(fromMaxDate)}
                        />
                    </div>
                </div>
            </div>
            <div data-testid={toTestId} className={`${colLgClass} ${colSmClass} ${containerClasses}`}>
                <div className="row">
                    <div className="col-12">
                        <div className="labelHead">{toLabel}</div>
                    </div>
                    <div className={`col-12 ${datepickerWrapperClass}`}>
                        <DatePickerComponent
                            dateField={filterData[toFieldName]}
                            handleDateChange={date => handleDateFieldChange(date, toFieldName)}
                            fieldName={toFieldName}
                            dateFormat={dateFormat}
                            timeSelect={showTimeSelect}
                            isRange={isRangeMode}
                            showFutureDate={showFutureDate}
                            adjustDateOnChange={adjustDateOnChange}
                            minDate={parseDateValue(toMinDate)}
                            maxDate={parseDateValue(toMaxDate)}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

FilterDateRange.propTypes = {
    filterData: PropTypes.object.isRequired,
    handleDateFieldChange: PropTypes.func.isRequired,
    fromLabel: PropTypes.string,
    toLabel: PropTypes.string,
    colLgClass: PropTypes.string,
    colSmClass: PropTypes.string,
    containerClasses: PropTypes.string,
    datepickerWrapperClass: PropTypes.string,
    dateFormat: PropTypes.string,
    fromFieldName: PropTypes.string,
    toFieldName: PropTypes.string,
    showTimeSelect: PropTypes.bool,
    isRangeMode: PropTypes.bool,
    showFutureDate: PropTypes.bool,
    adjustDateOnChange: PropTypes.bool,
    fromMinDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    fromMaxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    toMinDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    toMaxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    fromTestId: PropTypes.string,
    toTestId: PropTypes.string,
};

FilterDateRange.defaultProps = {
    fromLabel: 'From:',
    toLabel: 'To:',
    colLgClass: 'col-lg-3',
    colSmClass: 'col-sm-12',
    containerClasses: 'mobMb-10',
    datepickerWrapperClass: 'fontFix',
    dateFormat: 'MM-dd-yyyy',
    fromFieldName: 'dateFrom',
    toFieldName: 'dateTo',
    showTimeSelect: false,
    isRangeMode: false,
    showFutureDate: true,
    adjustDateOnChange: true,
    fromMinDate: null,
    fromMaxDate: null,
    toMinDate: null,
    toMaxDate: null,
    fromTestId: 'date-range-filter-from',
    toTestId: 'date-range-filter-to',
};

export default FilterDateRange;
